import type { IdPayload } from '@Application/Organizations/Workflows/Actions/organizationWorkflowsFetched';

export type DocumentTypeSectionFieldPayload = {
	readonly path: string;
	readonly label: string;
};

/** `path` '' is the general fields section; dependencies are expressed in paths, never in uuids. */
export type DocumentTypeSectionPayload = {
	readonly path: string;
	readonly title: string;
	readonly isReevaluation: boolean;
	readonly fields: readonly DocumentTypeSectionFieldPayload[];
};

/** `template` and `templateVersion` are null (and `sections` empty) when the type has no template. */
export type DocumentTypeSectionsPayload = {
	readonly template: IdPayload | null;
	readonly templateVersion: IdPayload | null;
	readonly sections: readonly DocumentTypeSectionPayload[];
};

export type DocumentTypeSectionsFetchedAction = {
	type: 'DOCUMENT_TYPE_SECTIONS_FETCHED';
	payload: DocumentTypeSectionsPayload;
	organizationId: number;
	documentTypeId: number;
};

export default (
	payload: DocumentTypeSectionsPayload,
	organizationId: number,
	documentTypeId: number,
): DocumentTypeSectionsFetchedAction => ({
	type: 'DOCUMENT_TYPE_SECTIONS_FETCHED',
	payload,
	organizationId,
	documentTypeId,
});
